module.exports = "/images/pillCalendar.png?b6f43936569f9d1d0508687837c42eb3";